if(typeof BSS_B2B != undefined) {
  setTimeout(() =>{
    const targetCart = document.querySelector("cart-drawer");
    if (targetCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
        BSS_B2B.makeChangesAfterClickAjaxCart(500)
      });
      mutationObserver.observe(targetCart, { attributes: true });
    }
  }, 300)

  if(window.location.pathname.includes("/products")) {
    setTimeout(() =>{
      BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, false);
    }, 2000)
  }
  
}